import { render, staticRenderFns } from "./SettingsRoleAuth.vue?vue&type=template&id=27c4e4b2&scoped=true&"
import script from "./SettingsRoleAuth.vue?vue&type=script&lang=js&"
export * from "./SettingsRoleAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c4e4b2",
  null
  
)

export default component.exports